import { render, staticRenderFns } from "./voiceGalleryPro.vue?vue&type=template&id=469dfbaa&scoped=true"
import script from "./voiceGalleryPro.vue?vue&type=script&lang=js"
export * from "./voiceGalleryPro.vue?vue&type=script&lang=js"
import style0 from "./voiceGalleryPro.vue?vue&type=style&index=0&id=469dfbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469dfbaa",
  null
  
)

export default component.exports